let singletonReactRoot: HTMLDivElement | null = null;

/**
 * Loads a react root element onto the
 * Ensures that the container is loaded only once
 */
export function getSingletonReactRoot() {
  if (!singletonReactRoot) {
    const node = document.createElement("div");
    node.setAttribute("id", "jsq-react-root");
    document.body.appendChild(node);
    singletonReactRoot = node;
  }

  return singletonReactRoot;
}
